import React, { FormEvent, useState } from 'react';
import { Button, Input } from '@bufferapp/ui';
import { addCommentToUpdate } from '~/post/thunks/addCommentToUpdate';
import { useAppDispatch } from '~/store';
import { AddCommentForm, InputWrapper } from './styles';

type Props = {
  postId: string;
};

export const AddComment = ({ postId }: Props) => {
  const dispatch = useAppDispatch();
  const [newComment, setNewComment] = useState<string>('');

  const handleSaveComment = (e: FormEvent): void => {
    dispatch(addCommentToUpdate({ postId, text: newComment }));
    setNewComment('');
    e.preventDefault();
  };

  return (
    <AddCommentForm onSubmit={handleSaveComment} autoComplete="off">
      <InputWrapper>
        <Input
          type="input"
          value={newComment}
          onChange={(e: InputEvent) =>
            setNewComment((e?.target as HTMLInputElement)?.value)
          }
          name="Add comment"
          placeholder="Add a comment..."
        />
      </InputWrapper>
      <Button
        type="primary"
        size="small"
        onClick={handleSaveComment}
        label="Send"
        disabled={!newComment?.length}
      />
    </AddCommentForm>
  );
};
